import { TextField } from '@material-ui/core/index';
import PropTypes from 'prop-types';
import React from 'react';
import { capitalizeFirstLetter } from '../../../utils';
import EditorRow from '../EditorRow';

function NameField(props) {
  const { label, id, type, value, disabled, margin } = props;
  return (
    <EditorRow width={350} margin={margin}>
      <label htmlFor={id}>
        {label ? label : `${capitalizeFirstLetter(type)} Name`}
      </label>
      <TextField
        id={id}
        className="editable-title"
        onChange={e => props.onChange(e)}
        value={value}
        placeholder={props.placeholder}
        size="small"
        disable={disabled}
        fullWidth={true}
      />
    </EditorRow>
  );
}

NameField.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NameField.defaultProps = {
  disabled: false,
  placeholder: 'e.g Drinks or Desserts',
};

export default NameField;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/NameField/index.jsx